import { Component, OnInit } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import { Shedule } from '../../classes/availableshedule.interface';
import { CommonService } from '../../services/common.service';
import { Serviceprovider } from '../../classes/serviceprovider.interface';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms/forms';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-addschedule',
  templateUrl: './addschedule.component.html',
  styleUrls: ['./addschedule.component.css']
})
export class AddscheduleComponent implements OnInit {
  day: string;
  spid: number;
  sch: Shedule;
  loading = false;
  msg: any;
  action: any;
  clinic: any;
  clinicid: any;
  constructor(private route: ActivatedRoute, private doctorservice:  DoctorService,
  private router: Router, private snackbar: MatSnackBar) {
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.spid = id;
       });
       this.route.params.subscribe(params => {
        const day = params['day'];
        this.day = day;
         });
    }

  ngOnInit() {
    this.getClicnic();
  }
  addMySchedule(form: NgForm) {
    this.loading = true;
    const at = ':00';
    const stime =  form.value.stime + at;
    const etime =  form.value.etime + at;
    this.doctorservice.addDaySchedule(this.spid, this.day, stime , etime  , form.value.sd ,form.value.cl)
    .subscribe(
      (x) => {
        this.loading = false;
        this.msg = 'Scheduled Added Successfully';
        this.openSnackBar();
       this.goToManageSchedule();
      });
  }
  goToManageSchedule() {
    this.router.navigate(['/doctor/manageschedule']);
  }
  openSnackBar() {
    this.snackbar.open(this.msg , this.action, {
      duration: 4000,
    });
  }
  getClicnic(){
    this.loading = true;
    this.doctorservice.getClinic()
    .subscribe(
      (x)=>{
        this.clinic = x;
        this.loading = false;
      });
  }
 
}
